export default __webpack_public_path__ + "static/media/Mastercard.d78a90f6.svg";